import { render, staticRenderFns } from "./list-compromiso.vue?vue&type=template&id=1d942fec"
import script from "./list-compromiso.vue?vue&type=script&lang=js"
export * from "./list-compromiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports